import React, { useRef, useEffect } from 'react';
import './IframeDetailsModal.scss'
const IframeDetailsModal = () => {
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            if (iframeRef.current) {
                iframeRef.current.style.height = window.innerHeight + 'px';
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);


        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="iframe-container">
            <iframe
                ref={iframeRef}
                src={'http://aquaman24.pl/lista_sterownikow.aspx?id=887738877&pin=03ac674216f3e15c761ee1a5e255f067953623c8b388b4459e13f978d7c846f4'}
                title="iframe content"
                style={{ width: '100%' }}
                // scrolling="no"
            />
        </div>
    );
};

export default IframeDetailsModal;
